import React from 'react';

const Filtros = props => (
  <div className='pageHead-rowContainer'>
    <div className='pageHead-filters wrapper'>
      <div className='row col-md-10'>
        <div className='col-md-3'>
          <label className='labelInfo' htmlFor='filialFilter'>Filial</label>
          <div className='select'>
            <select className='form-control' id='filialFilter' onChange={props.onChangeAndFilter} name='filialFilter' value={props.filialFilter}>
              <option value=''>Selecciona una filial</option>
              {
                props.filiales.map(filial => (
                  <option
                    key={filial.id}
                    value={filial.id}
                  >
                    {filial.nombre}
                  </option>
                ))
              }
            </select>
            <div className='select-control-icon'><i className='ion-arrow-down-b' /></div>
          </div>
        </div>
        <div className='col-md-3'>
          <label className='labelInfo' htmlFor='familiasFilter'>Familia</label>
          <div className='select'>
            <select className='form-control' id='familiasFilter' onChange={props.onChangeAndFilter} name='familiasFilter' value={props.familiasFilter}>
              <option value=''>Selecciona un tipo</option>
              {
              props.familias.map(tipo => (
                <option
                  key={tipo.codFamiliaVeh}
                  value={tipo.codFamiliaVeh}
                >
                  {tipo.desFamiliaVeh}
                </option>
              ))
            }
            </select>
            <div className='select-control-icon'><i className='ion-arrow-down-b' /></div>
          </div>
        </div>
        <div className='col-md-3'>
          <label className='labelInfo' htmlFor='tipoCapacidadFilter'>Tipo Capacidades</label>
          <div className='select'>
            <select className='form-control' id='tipoCapacidadFilter' onChange={props.onChangeAndFilter} name='tipoCapacidadFilter' value={props.tipoCapacidadFilter}>
              <option value=''>Selecciona un tipo</option>
              {
              props.tipoCapacidades.map(tipo => (
                <option
                  key={tipo.id}
                  value={tipo.id}
                >
                  {tipo.nombre}
                </option>
              ))
            }
            </select>
            <div className='select-control-icon'><i className='ion-arrow-down-b' /></div>
          </div>
        </div>
      </div>
      <button className='btn pageHead-tableConf-clean checkDeGrillaCerrar' data-toggle='tooltip' data-placement='top' title='Limpiar filtros' data-original-title='Limpiar filtros' onClick={props.reset}>
        <i className='ion-funnel' />
      </button>
    </div>
  </div>
);

export default Filtros;



// WEBPACK FOOTER //
// ./src/pages/MantCapacidades/Filtros.js